<template>
    <div>

    </div>
</template>

<script>
    import {
        Dialog
    } from 'vant';

    export default {
        name: "GoodsList3",
        components: {
            Dialog,
        },
        props: {
            content: {
                type: Array,
                default: [],
            },


        },

        data: function () {
            return {

            }
        },

        methods: {

        },

        filters: {}

    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// GoodsList3.vue?db0c64ba